import messagesForBuilder from "../../utils/messagesForBuilder";

const selectAll = 'Select all that apply';
const amount = 'Amount:';
const amountOther = 'Other Amount:';
const bankOther = 'Other Bank:';
const howMuch = 'How much:';
const whenYouNeed = 'When:';
const accessType = 'Access:';
const borrow = 'Borrow?';
const saved = 'Saved:';
const currentAccount_amount = 'Amount with Bank ($):';
const currentAccount_otherBankAmount = 'Amount at another Financial Institution ($):';
const currentAccount_otherBankName = 'Other bank name:';
const currentAccount_willingToMove = 'Amount willing to move to Bank (%):';
const currentAccount_willingToMoveDollars = 'Amount moving ($):';
const amountToBorrow = 'How much do you need?';
const loanTiming = 'How soon do you need the funds?';
const loanTimingOptions = {
  now: 'Immediate',
  three: '3 months',
  six: '6+ months',
  twelve: '1 year',
  more: 'Over a Year',
};
const loanAccess = 'How will you access the funds?';
const wantsToBorrow = 'Do you wish to borrow?';
const amountSaved = 'How much have you saved so far?';
const upFront = 'All at once';
const overTime = 'Over time';
const moving = 'Moving:';
const yes = 'Yes';
const no = 'No';
const yes_icon = 'fa fa-check-circle-o';
const no_icon = 'fa fa-times-circle-o';
const easy_icon = 'fa fa-check-circle-o';
const select_icon = 'fa fa-times-circle-o';

export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */

  'answers.title': 'Review Your Answers',
  'answers.subtext.previousPage': 'click here to return to the guide',

  'disclosures.subtext': 'Contact a branch or our Solutions Center for additional details.',

  'back': 'Back',

  'cart': 'Apply for Products',
  'cart.add': 'Add to cart',
  'cart.remove': 'Remove',
  'cart.cancel': 'Cancel',
  'cart.apply': 'Apply Now',
  'cart.apply.btn': 'Apply',
  'cart.contact': 'Contact Banker',
  'cart.contact.btn': 'Contact',
  'cart.contact.url': 'tel:8003252265',
  'cart.credit': 'Credit Cards',
  'cart.credit.btn': 'Apply for Credit',
  'cart.loan': 'Loans',
  'cart.loan.btn': 'Apply for Loan',
  'cart.mortgage': 'Mortgage',
  'cart.mortgage.btn': 'Apply for Mortgage',
  'cartApplyClicked.info.title': 'Thanks For Applying',
  'cartApplyClicked.info.message': 'You should have been re-directed to the appropriate page to apply for your products or ' +
    'to contact a banker. You can also click the "Apply For Products" button again to take action on more products.',
  'cartEmpty.error.title': 'No products selected',
  'cartEmpty.error.message': 'You must add products to your cart before applying',

  'cart.modal.title': 'Contact Details',

  'contactMe.submit': 'Continue',
  'contactForm.message': 'Before continuing with your products, please fill out the form below',
  'contactForm.success.title': 'Thank You',
  'contactForm.success.message': 'Your form was successfully submitted.',
  'editAnswer': 'Edit Answer',

  'error.title': 'Error',
  'error.question.required': 'This question requires an answer',
  'error.question.between': 'Value must be between {0} and {1}',
  'error.question.zipCode': 'Please enter a valid zip code',
  'error.question.postalCode': 'Please enter a valid zip code',
  'error.questionGroup.required': 'You must answer a question',
  'error.questionGroup.between': 'Total value must be between {0} and {1}',
  'error.questionGroup.equal': 'Total value must equal to {0}',

  'footer.phoneNumber': '800.325.2265',
  'footer.copyright': 'Copyright {year} Bank. All Rights Reserved',

  'guide.name': 'Modern Bank Guide',

  'landing.title': "Welcome To Ignite Dialogue",
  'landing.message': "Let's Find the Perfect Account for You.",
  'landing.readyToStart': "Let's Go",

  'logo': 'data:image/png;base64,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\n',

  'nav.prev': 'Back',
  'nav.next': 'Next',
  'next': 'Next',

  pleaseSelect: 'Please Select',

  'product.seeDetails': 'More Details',
  'product.applyBtn': 'Apply',
  'product.seeDetails.header': 'Product Details',
  'product.noDescription': 'Visit the Bank website or contact a banker to learn more about this product',
  'product.features.title': 'Why this product is right for you:',
  'product.services.title': 'Additional services with this product:',
  'product.disclosures': 'Disclosures',
  'productGroup.consumer-checking': 'Checking Products',
  'productGroup.consumer-checking-minors': 'Checking Products for Youth',
  'productGroup.consumer-money': 'Money Market Products',
  'productGroup.consumer-savings': 'Savings Products',
  'productGroup.consumer-cd': 'Certificate of Deposit Products',
  'productGroup.consumer-holiday': 'Holiday Products',
  'productGroup.consumer-mortgage': 'Mortgage Products',
  'productGroup.consumer-loans': 'Loan Products',
  'productGroup.consumer-credit': 'Credit Card Products',

  'shareViaEmail.title': 'Send Results via Email',
  'shareViaEmail.label': 'Enter an email address below and click send:',
  'shareViaEmail.button': 'Email Results',
  'shareViaEmail.placeholder': 'user@email.com',
  'shareViaEmail.submitted.success.title': 'Email Sent',
  'shareViaEmail.submitted.success.message': 'Your results have been sent to the email address you provided.',

  'shareViaSms.title': 'Send Results via Text Message',
  'shareViaSms.label': 'Enter a phone number below and click send:',
  'shareViaSms.button': 'Send Text Message',
  'shareViaSms.placeholder': '(800) 555-1234',
  'shareViaSms.submitted.success.title': 'Text Message Sent',
  'shareViaSms.submitted.success.message': 'A text message has been sent to the phone number you provided.',

  'sidebar.entry.text': 'Welcome to Bank, help us get to know you',
  'sidebar.goals.text': 'Understanding your financial goals to personalize the best solutions for you',
  'sidebar.banking.text': 'Understanding your current finances to meet your goals',
  'sidebar.personal.text': "Let's discuss your banking preferences",
  'sidebar.residency.text': 'Help us understand your living situation',
  'sidebar.credit.text': "Let's discuss credit options",
  'sidebar.exit.text': "Almost done, just a bit more information to personalize your solutions",

  'header.menu.start-over': "Go to beginning",
  'header.menu.new-guide': "Start a new guide",
  'header.menu.notes': "Notes",
  'header.menu.remoteSession': "Remote Session",
  'header.menu.logout': "Log out",
  'header.menu.employeeInfo': "Associate Details",

  'loggedOut.title': 'Logged Out',
  'loggedOut.message': 'You have successfully logged out',

  'summary.addAllProducts': 'Add All Products',
  'summary.back': 'Edit Answers',
  'summary.headerMenu.email': 'Email Results',
  'summary.headerMenu.sms': 'Text Results',
  'summary.headerMenu.print': 'Print',
  'summary.headerMenu.cart': 'Cart',
  'summary.subtitle': 'Congratulations, we were able to find your matching products.',
  'summary.title': 'Product Recommendations',

  /**
   * ============================
   * QUESTION MESSAGES
   * ============================
   */
  isCustomer: 'Let\'s get started. Are you a current customer of Bank?',
  'isCustomer.personal': 'Yes, personal',
  'isCustomer.business': 'Yes, business',
  'isCustomer.both': 'Yes, both personal and business',
  'isCustomer.none': 'No, not yet',

  reasonForVisit: 'What made you reach out to us today?',
  'reasonForVisit.subtext': selectAll,
  'reasonForVisit.find': 'Finding a bank who cares about my financial needs',
  'reasonForVisit.find.subtext': 'Financial Care',
  'reasonForVisit.understand': "Help understanding the right financial solutions",
  'reasonForVisit.understand.subtext': 'Solutions',
  'reasonForVisit.funds': 'I need additional funds to help accomplish my goal(s)',
  'reasonForVisit.funds.subtext': 'Funds',
  'reasonForVisit.location': 'Bank branch locations are convenient',
  'reasonForVisit.location.subtext': 'Convenience',
  'reasonForVisit.digital': "I'm looking to do more of my banking digitally",
  'reasonForVisit.digital.subtext': 'Digital Banking',
  'reasonForVisit.advice': 'A bank who listens to provide financial advice',
  'reasonForVisit.advice.subtext': 'Advice',

  'goalsQuestionGroup.subtext': 'Enter your goals below:',
  'goalTypes.cardBuilder.removeCard': '<i class="fa fa-times-circle-o"></i>',
  'goalTypes.cardBuilder.editCard': '<i class="fa fa-pencil-square-o"></i>',
  'goalTypes.cardBuilder.addCard': 'Enter Goal',
  'goalTypes.cardBuilder.modal.title': 'Select a goal from the options below.',

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'homeGoal',
    iconClass: 'fa fa-home',
    title: 'Purchase a Home',
    cardLabel: 'Purchase a Home'
  }),
  homeGoalAmount: amountToBorrow,
  'homeGoalAmount.tooltip': "( i.e. Purchase price – down payment = borrow amount )",
  'homeGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.homeGoalAmount': `Goals: Home | ${amountToBorrow}`,
  homeGoalTiming: loanTiming,
  'homeGoalTiming.0': loanTimingOptions.now,
  'homeGoalTiming.3': loanTimingOptions.three,
  'homeGoalTiming.6': loanTimingOptions.six,
  'homeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.homeGoalTiming': `Goals: Home | ${loanTiming}`,
  homeGoalPropertyType: 'Great! What type of home?',
  'homeGoalPropertyType.primary': 'Primary',
  'homeGoalPropertyType.secondary': 'Secondary',
  'homeGoalPropertyType.investment': 'Investment',
  'homeGoalWantsToBorrow': 'Do you wish to borrow?',
  'homeGoalWantsToBorrow.true': yes,
  'homeGoalWantsToBorrow.false': no,
  'details.homeGoalWantsToBorrow': `Goals: Home | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'refinanceHomeGoal',
    iconClass: 'fa fa-home',
    title: 'Refinance a Home',
    cardLabel: 'Refinance a Home'
  }),
  refinanceHomeGoalAmount: amountToBorrow,
  'refinanceHomeGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.refinanceHomeGoalAmount': `Goals: Home | ${amountToBorrow}`,
  refinanceHomeGoalTiming: loanTiming,
  'refinanceHomeGoalTiming.0': loanTimingOptions.now,
  'refinanceHomeGoalTiming.3': loanTimingOptions.three,
  'refinanceHomeGoalTiming.6': loanTimingOptions.six,
  'refinanceHomeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.refinanceHomeGoalTiming': `Goals: Refinance Home | ${loanTiming}`,
  refinanceHomeGoalType: 'Great! What type of home?',
  'refinanceHomeGoalType.primary': 'Primary',
  'refinanceHomeGoalType.secondary': 'Secondary',
  'refinanceHomeGoalType.investment': 'Investment',
  'refinanceHomeGoalType.cardBuilder.answerLabel': 'Type',

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'homeImprovementGoal',
    iconClass: 'fa fa-paint-brush',
    title: 'Home Improvements',
    cardLabel: 'Home Improvements'
  }),
  homeImprovementGoalAmount: amountToBorrow,
  'homeImprovementGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.homeImprovementGoalAmount': `Goals: Home Improvement | ${amountToBorrow}`,
  homeImprovementGoalTiming: loanTiming,
  'homeImprovementGoalTiming.0': loanTimingOptions.now,
  'homeImprovementGoalTiming.3': loanTimingOptions.three,
  'homeImprovementGoalTiming.6': loanTimingOptions.six,
  'homeImprovementGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.homeImprovementGoalTiming': `Goals: Home Improvement | ${loanTiming}`,
  homeImprovementGoalAccess: loanAccess,
  'homeImprovementGoalAccess.upFront': upFront,
  'homeImprovementGoalAccess.overTime': overTime,
  'homeImprovementGoalAccess.cardBuilder.answerLabel': accessType,
  'details.homeImprovementGoalAccess': `Goals: Home Improvement | ${loanAccess}`,
  'homeImprovementGoalWantsToBorrow': 'Do you wish to borrow?',
  'homeImprovementGoalWantsToBorrow.true': yes,
  'homeImprovementGoalWantsToBorrow.false': no,
  'details.homeImprovementGoalWantsToBorrow': `Goals: Home Improvement | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'vehicleGoal',
    iconClass: 'fa fa-car',
    title: 'Purchase a Vehicle',
    cardLabel: 'Purchase a Vehicle'
  }),
  vehicleGoalAmount: amountToBorrow,
  'vehicleGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.vehicleGoalAmount': `Goals: Vehicle | ${amountToBorrow}`,
  vehicleGoalTiming: loanTiming,
  'vehicleGoalTiming.0': loanTimingOptions.now,
  'vehicleGoalTiming.3': loanTimingOptions.three,
  'vehicleGoalTiming.6': loanTimingOptions.six,
  'vehicleGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.vehicleGoalTiming': `Goals: Vehicle | ${loanTiming}`,
  vehicleGoalType: 'Great! What type of vehicle?',
  'vehicleGoalType.auto': 'Auto',
  'vehicleGoalType.rv': 'RV (Recreational Vehicle)',
  'vehicleGoalType.motorcycle': 'Motorcycle',
  'vehicleGoalType.cardBuilder.answerLabel': 'Type',
  'vehicleGoalWantsToBorrow': 'Do you wish to borrow?',
  'vehicleGoalWantsToBorrow.true': yes,
  'vehicleGoalWantsToBorrow.false': no,
  'details.vehicleGoalWantsToBorrow': `Goals: Auto | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'refinanceVehicleGoal',
    iconClass: 'fa fa-bus',
    title: 'Refinance a Vehicle',
    cardLabel: 'Refinance a Vehicle'
  }),
  refinanceVehicleGoalAmount: amountToBorrow,
  'refinanceVehicleGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.refinanceVehicleGoalAmount': `Goals: Refinance Vehicle | ${amountToBorrow}`,
  refinanceVehicleGoalTiming: loanTiming,
  'refinanceVehicleGoalTiming.0': loanTimingOptions.now,
  'refinanceVehicleGoalTiming.3': loanTimingOptions.three,
  'refinanceVehicleGoalTiming.6': loanTimingOptions.six,
  'refinanceVehicleGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.refinanceVehicleGoalTiming': `Goals: Refinance Vehicle | ${loanTiming}`,
  refinanceVehicleGoalType: 'Great! What type of vehicle?',
  'refinanceVehicleGoalType.auto': 'Auto',
  'refinanceVehicleGoalType.rv': 'RV (Recreational Vehicle)',
  'refinanceVehicleGoalType.motorcycle': 'Motorcycle',
  'refinanceVehicleGoalType.cardBuilder.answerLabel': 'Type',

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'educationGoal',
    iconClass: 'fa fa-graduation-cap',
    title: 'Education',
    cardLabel: 'Education'
  }),
  educationGoalAmount: amountToBorrow,
  'educationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.educationGoalAmount': `Goals: Education | ${amountToBorrow}`,
  educationGoalSavings: amountSaved,
  'educationGoalSavings.cardBuilder.answerLabel': saved,
  'details.educationGoalSavings': `Goals: Education | ${amountSaved}`,
  educationGoalTiming: loanTiming,
  'educationGoalTiming.0': loanTimingOptions.now,
  'educationGoalTiming.3': loanTimingOptions.three,
  'educationGoalTiming.6': loanTimingOptions.six,
  'educationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.educationGoalTiming': `Goals: Education | ${loanTiming}`,
  'educationGoalWantsToBorrow': 'Do you wish to borrow?',
  'educationGoalWantsToBorrow.true': yes,
  'educationGoalWantsToBorrow.false': no,
  'details.educationGoalWantsToBorrow': `Goals: Education | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'vacationGoal',
    iconClass: 'fa fa-plane',
    title: 'Vacation / Travel',
    cardLabel: 'Vacation / Travel'
  }),
  vacationGoalAmount: amountToBorrow,
  'vacationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.vacationGoalAmount': `Goals: Vacation | ${amountToBorrow}`,
  vacationGoalSavings: amountSaved,
  'vacationGoalSavings.cardBuilder.answerLabel': saved,
  'details.vacationGoalSavings': `Goals: Vacation | ${amountSaved}`,
  vacationGoalTiming: loanTiming,
  'vacationGoalTiming.0': loanTimingOptions.now,
  'vacationGoalTiming.3': loanTimingOptions.three,
  'vacationGoalTiming.6': loanTimingOptions.six,
  'vacationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.vacationGoalTiming': `Goals: Vacation | ${loanTiming}`,
  'vacationGoalWantsToBorrow': 'Do you wish to borrow?',
  'vacationGoalWantsToBorrow.true': yes,
  'vacationGoalWantsToBorrow.false': no,
  'details.vacationGoalWantsToBorrow': `Goals: Life Event | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'lifeEventGoal',
    iconClass: 'fa fa-calendar',
    title: 'Future Event (Holidays, Taxes, Wedding, etc)',
    cardLabel: 'Future Event (Holidays, Taxes, Wedding, etc)'
  }),
  lifeEventGoalAmount: amountToBorrow,
  'lifeEventGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.lifeEventGoalAmount': `Goals: Future Event | ${amountToBorrow}`,
  lifeEventGoalSavings: amountSaved,
  'lifeEventGoalSavings.cardBuilder.answerLabel': saved,
  'details.lifeEventGoalSavings': `Goals: Future Event | ${amountSaved}`,
  lifeEventGoalTiming: 'When do you want to withdraw the money?',
  'lifeEventGoalTiming.september': 'Check distributed in September',
  'lifeEventGoalTiming.date': 'Check distibuted on date of my choice',
  'lifeEventGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.lifeEventGoalTiming': `Goals: Future Event | ${loanTiming}`,
  'lifeEventGoalWantsToBorrow': 'Do you wish to borrow?',
  'lifeEventGoalWantsToBorrow.true': yes,
  'lifeEventGoalWantsToBorrow.false': no,
  'details.lifeEventGoalWantsToBorrow': `Goals: Life Event | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'debtConsolidationGoal',
    iconClass: 'fa fa-money',
    title: 'Pay-off debts',
    cardLabel: 'Pay-off debts'
  }),
  debtConsolidationGoalAmount: amountToBorrow,
  'debtConsolidationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.debtConsolidationGoalAmount': `Goals: Pay-off debts | ${amountToBorrow}`,
  debtConsolidationGoalSavings: amountSaved,
  'debtConsolidationGoalSavings.cardBuilder.answerLabel': saved,
  'details.debtConsolidationGoalSavings': `Goals: Pay-off debts | ${amountSaved}`,
  debtConsolidationGoalTiming: loanTiming,
  'debtConsolidationGoalTiming.0': loanTimingOptions.now,
  'debtConsolidationGoalTiming.3': loanTimingOptions.three,
  'debtConsolidationGoalTiming.6': loanTimingOptions.six,
  'debtConsolidationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.debtConsolidationGoalTiming': `Goals: Pay-off debts | ${loanTiming}`,
  'debtConsolidationGoalWantsToBorrow': 'Do you wish to borrow?',
  'debtConsolidationGoalWantsToBorrow.true': yes,
  'debtConsolidationGoalWantsToBorrow.false': no,
  'details.debtConsolidationGoalWantsToBorrow': `Goals: Pay-off debts | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'majorPurchaseGoal',
    iconClass: 'fa fa-shopping-cart',
    title: 'Major Purchase',
    cardLabel: 'Major Purchase'
  }),
  majorPurchaseGoalAmount: amountToBorrow,
  'majorPurchaseGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.majorPurchaseGoalAmount': `Goals: Major Purchase | ${amountToBorrow}`,
  majorPurchaseGoalSavings: amountSaved,
  'majorPurchaseGoalSavings.cardBuilder.answerLabel': saved,
  'details.majorPurchaseGoalSavings': `Goals: Major Purchase | ${amountSaved}`,
  majorPurchaseGoalTiming: loanTiming,
  'majorPurchaseGoalTiming.0': loanTimingOptions.now,
  'majorPurchaseGoalTiming.3': loanTimingOptions.three,
  'majorPurchaseGoalTiming.6': loanTimingOptions.six,
  'majorPurchaseGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.majorPurchaseGoalTiming': `Goals: Major Purchase | ${loanTiming}`,
  majorPurchaseGoalAccess: loanAccess,
  'majorPurchaseGoalAccess.upFront': upFront,
  'majorPurchaseGoalAccess.overTime': overTime,
  'details.majorPurchaseGoalAccess': `Goals: Major Purchase | ${loanTiming}`,
  'majorPurchaseGoalWantsToBorrow': 'Do you wish to borrow?',
  'majorPurchaseGoalWantsToBorrow.true': yes,
  'majorPurchaseGoalWantsToBorrow.false': no,
  'details.majorPurchaseGoalWantsToBorrow': `Goals: Major Purchase | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'healthcareGoal',
    iconClass: 'fa fa-user-md',
    title: 'Healthcare',
    cardLabel: 'Healthcare'
  }),
  healthcareGoalAmount: amountToBorrow,
  'healthcareGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.healthcareGoalAmount': `Goals: Healthcare | ${amountToBorrow}`,
  healthcareGoalSavings: amountSaved,
  'healthcareGoalSavings.cardBuilder.answerLabel': saved,
  'details.healthcareGoalSavings': `Goals: Healthcare | ${amountSaved}`,
  healthcareGoalTiming: loanTiming,
  'healthcareGoalTiming.0': loanTimingOptions.now,
  'healthcareGoalTiming.3': loanTimingOptions.three,
  'healthcareGoalTiming.6': loanTimingOptions.six,
  'healthcareGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.healthcareGoalTiming': `Goals: Healthcare | ${loanTiming}`,
  healthcareGoalAccess: loanAccess,
  'healthcareGoalAccess.upFront': upFront,
  'healthcareGoalAccess.overTime': overTime,
  'details.healthcareGoalAccess': `Goals: Major Purchase | ${loanTiming}`,
  'healthcareGoalWantsToBorrow': 'Do you wish to borrow?',
  'healthcareGoalWantsToBorrow.true': yes,
  'healthcareGoalWantsToBorrow.false': no,
  'details.healthcareGoalWantsToBorrow': `Goals: Health Care | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'childSavingsGoal',
    iconClass: 'fa fa-users',
    title: 'Save for Child/Granchild',
    cardLabel: 'Save for Child/Granchild'
  }),
  childSavingsGoalAmount: amountToBorrow,
  'childSavingsGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.childSavingsGoalAmount': `Goals: Child Savings | ${amountToBorrow}`,
  childSavingsGoalSavings: amountSaved,
  'childSavingsGoalSavings.cardBuilder.answerLabel': saved,
  'details.childSavingsGoalSavings': `Goals: Child Savings | ${amountSaved}`,
  childSavingsGoalTiming: loanTiming,
  'childSavingsGoalTiming.0': loanTimingOptions.now,
  'childSavingsGoalTiming.3': loanTimingOptions.three,
  'childSavingsGoalTiming.6': loanTimingOptions.six,
  'childSavingsGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.childSavingsGoalTiming': `Goals: Child Savings | ${loanTiming}`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'rainyDayGoal',
    iconClass: 'fa fa-usd',
    title: 'Save for Emergencies',
    cardLabel: 'Save for Emergencies'
  }),
  rainyDayGoalAmount: amountToBorrow,
  'rainyDayGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.rainyDayGoalAmount': `Goals: Save for Emergencies | ${amountToBorrow}`,
  rainyDayGoalSavings: amountSaved,
  'rainyDayGoalSavings.cardBuilder.answerLabel': saved,
  'details.rainyDayGoalSavings': `Goals: Save for Emergencies | ${amountSaved}`,
  rainyDayGoalTiming: loanTiming,
  'rainyDayGoalTiming.0': loanTimingOptions.now,
  'rainyDayGoalTiming.3': loanTimingOptions.three,
  'rainyDayGoalTiming.6': loanTimingOptions.six,
  'rainyDayGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.rainyDayGoalTiming': `Goals: Save for Emergencies | ${loanTiming}`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'otherGoal',
    iconClass: 'fa fa-ellipsis-h',
    title: 'Other Goal'
  }),
  otherGoalAmount: amountToBorrow,
  'otherGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.otherGoalAmount': `Goals: Other Goal | ${amountToBorrow}`,
  otherGoalTiming: loanTiming,
  'otherGoalTiming.0': loanTimingOptions.now,
  'otherGoalTiming.3': loanTimingOptions.three,
  'otherGoalTiming.6': loanTimingOptions.six,
  'otherGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.otherGoalTiming': `Goals: Other Goal | ${loanTiming}`,
  'otherGoalWantsToBorrow': 'Do you wish to borrow?',
  'otherGoalWantsToBorrow.true': yes,
  'otherGoalWantsToBorrow.false': no,
  'details.otherGoalWantsToBorrow': `Goals: Other | ${ wantsToBorrow }`,

  goalsAmountTotal: 'Total amount needed for goals:',
  goalsAmountTotalToBorrow: 'Total amount to borrow:',

  currentAccountsQuestionGroup: "Please tell me about your current finances to better personalize solutions for your needs.",
  'currentAccountsQuestionGroup.subtext': 'Add any current accounts that you have:',
  'currentAccountTypes.cardBuilder.addCard': 'Add Account',
  'currentAccountTypes.cardBuilder.removeCard': '<i class="fa fa-times-circle-o"></i>',
  'currentAccountTypes.cardBuilder.editCard': '<i class="fa fa-pencil-square-o"></i>',
  'currentAccountTypes.cardBuilder.modal.title': 'Select an an account type from the options below.',
  currentAccountTypes: 'Account Types:',

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'checking',
    iconClass: 'fa fa-money',
    title: 'Checking'
  }),
  checkingBalance: currentAccount_amount,
  'details.checkingBalance': `Current checking account | ${currentAccount_amount}`,
  checkingBalanceOtherBank: currentAccount_otherBankAmount,
  'details.checkingBalanceOtherBank': `Current checking account | ${currentAccount_otherBankAmount}`,
  checkingBalanceAmountToMovePct: currentAccount_willingToMove,
  'details.checkingBalanceAmountToMovePct': `Current checking account | ${currentAccount_willingToMove}`,
  'checkingBalance.cardBuilder.answerLabel': amount,
  'checkingBalanceOtherBank.cardBuilder.answerLabel': amountOther,
  'checkingBalanceAmountToMovePct.cardBuilder.answerLabel': moving,
  checkingBalanceAmountToMove: `Checking ${currentAccount_willingToMoveDollars}`,
  directDepositAmount: 'What is the total amount of direct deposits to your checking each month ($)?',

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'savings',
    iconClass: 'fa fa-usd',
    title: 'Savings'
  }),
  savingsBalance: currentAccount_amount,
  'details.savingsBalance': `Current savings account | ${currentAccount_amount}`,
  savingsBalanceOtherBank: currentAccount_otherBankAmount,
  'details.savingsBalanceOtherBank': `Current savings account | ${currentAccount_otherBankAmount}`,
  savingsBalanceAmountToMovePct: currentAccount_willingToMove,
  'details.savingsBalanceAmountToMovePct': `Current savings account | ${currentAccount_willingToMove}`,
  'savingsBalance.cardBuilder.answerLabel': amount,
  'savingsBalanceOtherBank.cardBuilder.answerLabel': amountOther,
  'savingsBalanceAmountToMovePct.cardBuilder.answerLabel': moving,
  savingsBalanceAmountToMove: `Savings ${currentAccount_willingToMoveDollars}`,

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'cd',
    iconClass: 'fa fa-bank',
    title: 'CD Account'
  }),
  cdBalance: currentAccount_amount,
  'details.cdBalance': `Current CD account | ${currentAccount_amount}`,
  cdBalanceOtherBank: currentAccount_otherBankAmount,
  'details.cdBalanceOtherBank': `Current CD account | ${currentAccount_otherBankAmount}`,
  cdBalanceAmountToMovePct: currentAccount_willingToMove,
  'details.cdBalanceAmountToMovePct': `Current CD account | ${currentAccount_willingToMove}`,
  'cdBalance.cardBuilder.answerLabel': amount,
  'cdBalanceOtherBank.cardBuilder.answerLabel': amountOther,
  'cdBalanceAmountToMovePct.cardBuilder.answerLabel': moving,
  cdBalanceAmountToMove: `CD ${currentAccount_willingToMoveDollars}`,

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'loans',
    iconClass: 'fa fa-exchange',
    title: 'Loan / Line(s) of Credit'
  }),
  loanTypes: 'What other types of loans do you have:',
  'loanTypes.cardBuilder.answerLabel': 'Types',
  loansBalance: 'With Bank ($)',
  'loansBalance.cardBuilder.answerLabel': 'Balance',

  depositAccountsTotal: 'Deposit account(s) balance:',

  checkingAccountQuestionGroup: 'How would you describe your banking activity each month?',
  'checkingAccountQuestionGroup.subtext': 'Checking Account(s)',
  checksWritten: 'Checks written (#):',
  'checksWritten.input.placeholder': '',
  debitUsage: 'Debit cards (#):',
  'debitUsage.input.placeholder': '',
  onlineBankingBillsPaid: 'Pay bills through online banking (#):',
  'onlineBankingBillsPaid.input.placeholder': '',
  atmUsage: 'Withdrawals from Bank ATMs (#):',
  'atmUsage.input.placeholder': '',
  atmUsageOther: 'Withdrawals from Other Financial Institution ATMs (Non-Bank) (#):',
  'atmUsageOther.input.placeholder': '',

  savingsAccountQuestionGroup: 'How would you describe your banking activity each month?',
  'savingsAccountQuestionGroup.subtext': 'Savings Account(s)',
  savingsDepositFrequency: 'Deposits (#):',
  savingsWithdrawalFrequency: 'Withdrawals (#):',
  savingsAtmFrequency: 'Withdrawals from Bank ATMs (#):',
  savingsAtmFrequencyOther: 'Withdrawals from Other Financial Institution ATMs (Non-Bank) (#):',

  cdPreference: 'Are you interested in either of these options for a Certificate of Deposit account?',
  'cdPreference.subtext': selectAll,
  'cdPreference.withdraw': 'Ability to withdraw funds prior to maturity',
  'cdPreference.withdraw.subtext': 'Early Withdrawal',
  'cdPreference.deposit': 'Depositing additional funds prior to maturity',
  'cdPreference.deposit.subtext': 'Additional Deposits',
  'cdPreference.none': 'I am not interested in any of the available options',
  'cdPreference.none.subtext': 'Neither',

  electronicStatements: 'Which type of statements do you prefer for your savings account?',
  'electronicStatements.electronic': 'Electronic statements',
  'electronicStatements.electronic.subtext': 'Digital',
  'electronicStatements.paper': 'Printed, quarterly statements',
  'electronicStatements.paper.subtext': 'Paper',
  'electronicStatements.passbook': 'I prefer having a Passbook',
  'electronicStatements.passbook.subtext': 'Passbook',

  wantsInterest: 'Would you say that earning interest is a top priority for you?',
  'wantsInterest.true': yes,
  'wantsInterest.true.icon': yes_icon,
  'wantsInterest.false': 'No preference',
  'wantsInterest.false.icon': no_icon,

  basicCheckingPreference: 'It sounds like a basic checking account would fit you best. Which of these options appeal to you the most?',
  'basicCheckingPreference.select': '<h4>Unlimited check writing</h4> No monthly service charge, Overdraft fees apply as applicable, Ability to write unlimited checks and use debit card',
  'details.basicCheckingPreference.select': 'No monthly service charge, Overdraft fees apply as applicable, Ability to write unlimited checks and use debit card',
  'basicCheckingPreference.easy': '<h4>Checkless</h4> Low fixed monthly fee, No overdraft fees, No-fee debit card, no checks',
  'details.basicCheckingPreference.easy': 'Low fixed monthly fee, No overdraft fees, No-fee debit card, no checks',

  ownershipStatus: 'Do you currently own or rent your home?',
  'ownershipStatus.rent': 'Rent',
  'ownershipStatus.own': 'Own',
  'ownershipStatus.other': 'Living with friends or relatives',

  homeValueQuestionGroup: 'Can you tell us more about your home?',
  homeValue: 'What is the estimated value of the home you own:',
  mortgageBalance: 'How much do you owe on your home, if any:',
  homeEquityAmountAvailable: 'Home equity available:',

  useHomeEquity: 'Would you like to use your home equity to borrow towards your goals?',
  'useHomeEquity.vehicleGoal': 'Purchase a Vehicle',
  'useHomeEquity.debtConsolidationGoal': 'Pay-off debts',
  'useHomeEquity.educationGoal': 'Education',
  'useHomeEquity.healthcareGoal': 'Healthcare',
  'useHomeEquity.homeGoal': 'Purchase a Home',
  'useHomeEquity.homeImprovementGoal': 'Home Improvements',
  'useHomeEquity.refinanceHomeGoal': 'Refinance a Home',
  'useHomeEquity.retirementGoal': 'Retirement',
  'useHomeEquity.childSavingsGoal': 'Save for Child/Grandchild',
  'useHomeEquity.vacationGoal': 'Vacation / Travel',
  'useHomeEquity.refinanceVehicleGoal': 'Refinance a Vehicle',
  'useHomeEquity.majorPurchaseGoal': 'Major Purchase',
  'useHomeEquity.lifeEventGoal': 'Future Event (Holidays, Taxes, Wedding, etc)',
  'useHomeEquity.rainyDayGoal': 'Save for Emergencies',
  'useHomeEquity.otherGoal': 'Other',
  'useHomeEquity.none': 'No, thank you',

  homeEquityAmountTotal: 'Home Equity Available: ',
  homeEquityAmountToBorrow: 'Selected Equity Amount to Borrow: ',

  wantsCreditCard: 'Do you currently use credit cards or would like to?',
  'wantsCreditCard.true': yes,
  'wantsCreditCard.true.icon': yes_icon,
  'wantsCreditCard.false': no,
  'wantsCreditCard.false.icon': no_icon,

  creditCardUsageQuestionGroup: 'Tell us about your credit card usage.',
  creditCardUsage: 'How do / would you like to use your credit card(s)?',
  'creditCardUsage.subtext': selectAll,
  'creditCardUsage.dayPurchases': 'Everyday purchases',
  'creditCardUsage.travel': 'Travel',
  'creditCardUsage.buildCredit': 'Build / rebuild credit',
  'creditCardUsage.balanceTransfer': 'Transfer balance to consolidate debt',
  'creditCardUsage.college': 'College purchases or expenses',

  creditCardFeatures: "Which type of card do you prefer?",
  'creditCardFeatures.lowInterest': 'Low interest rate',
  'creditCardFeatures.cashRewards': 'Cash rewards',
  'creditCardFeatures.rewards': 'Reward points to use towards gift cards, travel and merchandise',

  creditCardTravel: 'Would you be willing to pay an annual fee if TSA Pre-check or Global Entry fees were reimbursed to your account?',
  'creditCardTravel.true': yes,
  'creditCardTravel.true.icon': yes_icon,
  'creditCardTravel.false': no,
  'creditCardTravel.false.icon': no_icon,

  homeOwnerStatus: 'Can you tell me a little more about yourself? We may have unique options for you.',
  'homeOwnerStatus.subtext': selectAll,
  'homeOwnerStatus.veteran': 'A veteran or currently enlisted in the military',
  'homeOwnerStatus.veteran.subtext': 'Veteran / Active Military',
  'homeOwnerStatus.first': 'Interested or in the process of buying first home',
  'homeOwnerStatus.first.subtext': 'Buying First Home',
  'homeOwnerStatus.none': 'None of the above',
  'homeOwnerStatus.none.subtext': 'Neither of the topics above apply to me',

  ageBasedBenefits: 'Are you interested in learning more about the amazing benefits Bank offers for individuals under 24 years of age?',
  'ageBasedBenefits.subtext': selectAll,
  'ageBasedBenefits.younger': 'Yes, for someone under 13',
  'ageBasedBenefits.younger.subtext': 'Age 13 and Under',
  'ageBasedBenefits.older': 'Yes, for someone between 14-24',
  'ageBasedBenefits.older.subtext': 'Age 14-24',
  'ageBasedBenefits.none': 'No, thank you',
  'ageBasedBenefits.none.subtext': 'Not Interested',

  demographicsQuestionGroup: 'A bit more about you:',
  'age.input.placeholder': 'Enter your age',
  postalCode: 'Where do you live?',
  'postalCode.input.placeholder': 'Enter your zip code',

  accounts_checking_balance: 'Average checking balance (monthly) ',
  accounts_checking_minimum_balance: 'Minimum checking balance',
  accounts_retirement_type: 'For your retirement plan, which type of rate do you prefer?',
  'accounts_retirement_type.fixed': 'Fixed',
  'accounts_retirement_type.variable': 'Variable',
  accounts_totalDeposit: 'Average combined deposit balance (monthly) (i) Total of checking, savings, cd and money market',
  age: 'Age',
  annualIncome: 'Income',
  checkingAccountBalances: 'Understanding your checking account.',
  checkingAccountBalancesQuestionGroup: 'On average, what is your:',
  checkingAccountUsage: 'Discovering how you use your checking account.',
  checkingAccountUsageQuestionGroup: 'How many times per month do you?',
  customerType: 'Which types of accounts do you currently have with ${clientName}? ',
  customerTypeQuestionGroup: 'Tell us about your relationship with ${clientName}.',
  'customerType.both': 'Both personal and business accounts ',
  'customerType.business': 'Business accounts ',
  'customerType.none': 'None',
  'customerType.personal': 'Personal accounts ',
  gender: 'Gender',
  'gender.female': 'Female',
  'gender.male': 'Male',
  'gender.noAnswer': 'Prefer not to answer',
  goalTypes: '',
  'goalTypes_ goals_rainyDay': 'Rainy day',
  'goalTypes_ goals_secondHomePurchase': 'Buy second home / investment property',
  goalTypes_goals_debtConsolidation: 'Consolidate debt ',
  goalTypes_goals_education: 'Education',
  goalTypes_goals_healthcare: 'Healthcare',
  goalTypes_goals_homeImprovement: 'Home improvement ',
  goalTypes_goals_homePurchase: 'Buy a home ',
  goalTypes_goals_homeRefinance: 'Refinance home',
  goalTypes_goals_lifeEvent: 'Major life event ',
  goalTypes_goals_majorPurchase: 'Major purchase ',
  goalTypes_goals_other: 'Save for Child or Grandchild ',
  goalTypes_goals_retirement: 'Retirement / Estate planning',
  goalTypes_goals_vehiclePurchase: 'Vehicle',
  goal_amount: 'How much will you need? ',
  goal_amountSaved: 'How much have you saved? ',
  goalsQuestionGroup: 'Examining your goals.',
  goals_access: 'How will you access the money? Up front, Over time ',
  goals_vehiclePurchase_timing: 'When will you need the money? ',
  'goals_vehiclePurchase_timing.1': ' Immediate',
  'goals_vehiclePurchase_timing.12': '1 year',
  'goals_vehiclePurchase_timing.13': 'Over a Year',
  'goals_vehiclePurchase_timing.6': '6 months',
  goals_wantsToBorrow: 'Do you wish to borrow? ',
  'goals_wantsToBorrow.false': 'No',
  'goals_wantsToBorrow.true': 'Yes',
  homeEquity_homeValue: 'What is the estimated value of your home?',
  homeEquity_homeValueQuestionGroup: 'Home ownership.',
  homeEquity_mortgageAmount: 'How much do you owe on your mortgage?',
  isHomeOwner: 'Do  you own a home?',
  isHomeOwnerQuestionGroup: 'Home ownership.',
  'isHomeOwner.false': 'No',
  'isHomeOwner.true': 'Yes',
  isStudent: 'Student',
  'isStudent.false': 'No',
  'isStudent.true': 'Yes',
  personalDetailsQuestionGroup: 'A few more questions before we show you your personalized recommendations.',
  preferences_bankingFeatures: 'Which of the following features and services are important to you?\nSelect all that apply',
  preferences_bankingFeaturesQuestionGroup: 'Understanding how you like to bank.',
  'preferences_bankingFeatures.onlineAndMobileAccess': 'Online/mobile account access ',
  'preferences_bankingFeatures.overdraftProtection': 'Overdraft protection ',
  'preferences_bankingFeatures.cashBack': 'Cash back ',
  'preferences_bankingFeatures.cellPhoneInsurance': 'Cell phone insurance ',
  'preferences_bankingFeatures.discounts': 'Discounts / Coupons ',
  'preferences_bankingFeatures.earningInterest': 'Earning interest ',
  'preferences_bankingFeatures.none': 'None',
  'preferences_bankingFeatures.onlineAndMobileBillPay': 'Online /mobile bill pay ',
  'preferences_bankingFeatures.paperlessStatements': 'Paperless statements ',
  'preferences_bankingFeatures.rewards': 'Rewards',
  preferences_checksPerMonth: 'Write a check',
  preferences_creditCardsFeaturesQuestionGroup: 'Which is most important to you when considering a CC? ',
  'preferences_creditCardsFeatures.balanceTransfers': 'Balance Transfers ',
  'preferences_creditCardsFeatures.lowInterest': 'Low Interest ',
  'preferences_creditCardsFeatures.noAnnualFee': 'No Annual Fee ',
  'preferences_creditCardsFeatures.rewards': 'Rewards',
  preferences_debitCardTransactionsPerMonth: 'Use your debit card',
  preferences_directDepositsPerMonth: 'Use direct deposit',
  preferences_exploreCreditCardsQuestionGroup: 'Are you interested in exploring our credit card options?  ',
  'preferences_exploreCreditCards.false': 'No',
  'preferences_exploreCreditCards.true': 'Yes',
  preferences_exploreGoalsQuestionGroup: 'We can help with all your financial needs.',
  'preferences_exploreGoals.false': 'No thank you. ',
  'preferences_exploreGoals.true': 'Yes, please do. ',
  preferences_haveHighDeductibleHealthPlan: 'You indicated that you want to save for your healthcare, do you participate in a high-deductible health plan? ',
  'preferences_haveHighDeductibleHealthPlan.false': 'No',
  'preferences_haveHighDeductibleHealthPlan.true': 'Yes',
  preferences_pathSelection: 'How may we help you today?\nSelect all that apply',
  preferences_pathSelectionQuestionGroup: 'Together we will find the customized solutions to fit your needs.',
  'preferences_pathSelection.borrowing': 'Address a borrowing need ',
  'preferences_pathSelection.checking': 'Open a checking account ',
  'preferences_pathSelection.review': 'Full financial review',
  'preferences_pathSelection.savings': 'Open a savings or investment account ',
  preferences_reasonForVisit: 'What brought you into ${clientName} today? ',
  preferences_reasonForVisitQuestionGroup: 'Why you choose ${clientName}.',
  'preferences_reasonForVisit.advertisement': 'Advertisement',
  'preferences_reasonForVisit.location': 'Location',
  'preferences_reasonForVisit.other': 'Other',
  'preferences_reasonForVisit.referred': 'Referred by family / friend ',
  '1050371.name.name': 'Rewards Checking',
  '1050371.description.name': 'Earn amazing rewards with your My Carter Rewards Checking account! This free account is great for debit card users and offers nationwide ATM fee refunds. There are no minimum balance requirements or service fees…simply a great checking with a great rate!',
  '1050371.description.abbreviated.name': 'Earn amazing rewards with your My Carter Rewards Checking account!',
  '1050371.url.name': 'https://www.cartercu.org/Accounts/Checking?panel=Rewards-Checking#Rewards-Checking',
  '1050371.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050371.disclosure.count.name': '1',
  '1050371.disclosure.1.name': 'Qualifiers for Beyond Rewards Checking must be met during statement cycle to earn 2.25% APY\n\nNon-qualifying rate: 0.11% (if qualifiers are not met wtih each statement cycle)',
  '1050371.features.count.name': '4',
  '1050371.features.1.name': 'Free account',
  '1050371.features.2.name': 'Earns 2.25% APY on balances up to $10,000',
  '1050371.features.3.name': '0.25% APY on balances above $10,000',
  '1050371.features.4.name': 'Nationwide ATM refunds up to $25 per cycle',
  '1050384.name.name': 'Classic Checking',
  '1050384.description.name': 'Carter Classic Checking offers competitive dividend earnings for members who maintain a higher monthly balance. Members can avoid the monthly service charge by maintaining a daily balance of $1,000.',
  '1050384.description.abbreviated.name': 'Carter Classic Checking offers competitive dividend earnings for members who maintain a higher monthly balance.',
  '1050384.url.name': 'https://www.cartercu.org/Accounts/Checking?panel=Classic-Checking#Classic-Checking',
  '1050384.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050384.disclosure.count.name': '1',
  '1050384.disclosure.1.name': '1 Must maintain $1,000 daily balance to avoid $7 monthly service charge',
  '1050384.features.count.name': '2',
  '1050384.features.1.name': 'No monthly service fees1',
  '1050384.features.2.name': 'Earns exceptional dividends',
  '1050385.name.name': 'Cash Back Checking',
  '1050385.description.name': 'Choose the free checking account that pays you back — Carter Cash Back pays you 3.00% cash back* on your everyday debit card purchases. That’s not all…Also enjoy up to $25 in refunds on ATM fees* nationwide!\n\nEarning these rewards is simple. You are probably already qualified so you can start earning your cash back right away!',
  '1050385.description.abbreviated.name': 'Choose the free checking account that pays you back — Carter Cash Back pays you 3.00% cash back* on your everyday debit card purchases.',
  '1050385.url.name': 'https://www.cartercu.org/Accounts/Checking?panel=Classic-Checking#Cash-Back-Checking',
  '1050385.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050385.disclosure.count.name': '1',
  '1050385.disclosure.1.name': '*Cash back earned on debit card purchases up to $300 per statement cycle',
  '1050385.features.count.name': '5',
  '1050385.features.1.name': 'Free account',
  '1050385.features.2.name': 'No minimum balance required',
  '1050385.features.3.name': 'No monthly service fees',
  '1050385.features.4.name': 'Earns 3% cash back on debit card purchases up to $300',
  '1050385.features.5.name': 'Nationwide ATM refunds up to $25 per cycle',
  '1050388.name.name': 'Free Checking',
  '1050388.description.name': "Carter's Free Checking account helps keep things simple for you. Our Free Checking account is great as a household account.",
  '1050388.description.abbreviated.name': "Carter's Free Checking account helps keep things simple for you.",
  '1050388.url.name': 'https://www.cartercu.org/Accounts/Checking?panel=Classic-Checking#Free-Checking',
  '1050388.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050388.features.count.name': '4',
  '1050388.features.1.name': 'Free account',
  '1050388.features.2.name': 'No minimum balance required',
  '1050388.features.3.name': 'No monthly service fees',
  '1050388.features.4.name': 'Free VISA debit card',
  '1050404.name.name': 'Home Equity Loan',
  '1050404.description.name': "Let the value of your home work for you. Whether you're interested in debt consolidation, home improvements, or anything in between, your home just might be the means to your needs. We'll help you turn the equity in your home into collateral to finance a wide range of needs.\n\nWe offer competitively low rates and terms to meet your needs. Best of all, the interest may even be tax deductible!",
  '1050404.description.abbreviated.name': "Let the value of your home work for you. Whether you're interested in debt consolidation, home improvements, or anything in between, your home just might be the means to your needs.",
  '1050404.url.name': 'https://www.cartercu.org/Loans/Home?panel=Home-Equity#Home-Equity',
  '1050404.disclosure.count.name': '1',
  '1050404.disclosure.1.name': 'Property subject to appraisal, loan to value, credit history restrictions, loan amount and conditions may apply. Rates, terms, and APR are subject to change without notice. Visit your Carter Representative and apply today!',
  '1050404.features.count.name': '5',
  '1050404.features.1.name': 'Competitive interest rates',
  '1050404.features.2.name': 'Interest may be tax deductible (contact your tax advisor)',
  '1050404.features.3.name': 'Flexible terms, customized to your situation',
  '1050404.features.4.name': 'A wide range of terms and lending options',
  '1050404.features.5.name': 'Friendly, personalized service from start to finish',
  '1050405.name.name': 'Home Equity Line of Credit',
  '1050405.description.name': "Let the value of your home work for you. Whether you're interested in debt consolidation, home improvements, or anything in between, your home just might be the means to your needs. We'll help you turn the equity in your home into collateral to finance a wide range of needs.\n\nWe offer competitively low rates and terms to meet your needs. Best of all, the interest may even be tax deductible!",
  '1050405.description.abbreviated.name': "Let the value of your home work for you. Whether you're interested in debt consolidation, home improvements, or anything in between, your home just might be the means to your needs.",
  '1050405.url.name': 'https://www.cartercu.org/Loans/Home?panel=Home-Equity#Home-Equity',
  '1050405.disclosure.count.name': '1',
  '1050405.disclosure.1.name': 'Property subject to appraisal, loan to value, credit history restrictions, loan amount and conditions may apply. Rates, terms, and APR are subject to change without notice. Visit your Carter Representative and apply today!',
  '1050405.features.count.name': '5',
  '1050405.features.1.name': 'Competitive interest rates',
  '1050405.features.2.name': 'Interest may be tax deductible (contact your tax advisor)',
  '1050405.features.3.name': 'Flexible terms, customized to your situation',
  '1050405.features.4.name': 'A wide range of terms and lending options',
  '1050405.features.5.name': 'Friendly, personalized service from start to finish',
  '1050403.name.name': 'Mortgage Loan',
  '1050403.description.name': 'If you are looking to purchase that new home, and are searching for that “Desired Mortgage Experience” then Carter Federal Credit Union is the place for you. Our professional partnership with Member Advantage Mortgage provides our members with exceptional mortgage lending products and service. Apply today and make your dream of owning a home a reality!',
  '1050403.description.abbreviated.name': 'If you are looking to purchase that new home, and are searching for that “Desired Mortgage Experience” then Carter Federal Credit Union is the place for you.',
  '1050403.url.name': 'https://www.cartercu.org/Loans/Home?panel=Mortage-Loans#Mortage-Loans',
  '1050403.applicationUrl.name': 'www.memberadvantagemortgage.com',
  '1050403.features.count.name': '4',
  '1050403.features.1.name': 'Local lenders to serve you',
  '1050403.features.2.name': 'Exceptionally priced, value-driven lending products',
  '1050403.features.3.name': 'Personalized service specific to your needs',
  '1050403.features.4.name': 'Quick decisioning',
  '1050406.name.name': 'Auto Loan',
  '1050406.description.name': '',
  '1050406.description.abbreviated.name': '',
  '1050407.name.name': 'Recreational Vehicle Loan',
  '1050407.description.name': '',
  '1050407.description.abbreviated.name': '',
  '1050400.name.name': 'Share Certificates',
  '1050400.description.name': "If you're looking for a safe, long-term investment strategy, a Share Certificate or an Individual Retirement Account (IRA) is a great place to start. With all the ups and downs on the stock market, it's reassuring to know that a Carter Certificate Account will never lose its original value.",
  '1050400.description.abbreviated.name': "If you're looking for a safe, long-term investment strategy, a Share Certificate or an Individual Retirement Account (IRA) is a great place to start.",
  '1050400.url.name': 'https://www.cartercu.org/Accounts/Savings#Certificates-IRAs',
  '1050400.applicationUrl.name': 'https://www.cartercu.org/Resources/Forms-Applications/Account-Application',
  '1050400.features.count.name': '3',
  '1050400.features.1.name': 'Minimum opening deposit $1,000',
  '1050400.features.2.name': 'Dividend-earning rate is higher than standard savings rates',
  '1050400.features.3.name': 'Terms from 6 months to 5 years',
  '1050401.name.name': 'Individual Retirement Accounts',
  '1050401.description.name': "If you're looking for a safe, long-term investment strategy, a Share Certificate or an Individual Retirement Account (IRA) is a great place to start. With all the ups and downs on the stock market, it's reassuring to know that a Carter Certificate Account will never lose its original value.",
  '1050401.description.abbreviated.name': "If you're looking for a safe, long-term investment strategy, a Share Certificate or an Individual Retirement Account (IRA) is a great place to start.",
  '1050401.url.name': 'https://www.cartercu.org/Accounts/Savings#Certificates-IRAs',
  '1050401.applicationUrl.name': 'https://www.cartercu.org/Resources/Forms-Applications/Account-Application',
  '1050401.features.count.name': '4',
  '1050401.features.1.name': "Traditional, ROTH, and Education IRA's",
  '1050401.features.2.name': 'Minimum opening deposit $1,000',
  '1050401.features.3.name': 'Terms from 6 months to 5 years',
  '1050401.features.4.name': 'Tax benefits available - Consult your tax advisor',
  '1050398.name.name': 'Health Savings Account',
  '1050398.description.name': 'Health Savings Accounts (HSA) are designed for individuals who carry a high-deductible health plan. The HSA can be used as a tax advantage to offset health care expenses.',
  '1050398.description.abbreviated.name': 'Health Savings Accounts (HSA) are designed for individuals who carry a high-deductible health plan.',
  '1050398.url.name': 'https://www.cartercu.org/Accounts/Savings#Health-Savings',
  '1050398.applicationUrl.name': 'https://www.cartercu.org/Resources/Forms-Applications/Account-Application',
  '1050398.disclosure.count.name': '1',
  '1050398.disclosure.1.name': "* Federal tax laws regulate HSA's; therefore, you are encouraged to access the most current and more detailed information at The Department of Treasury website.",
  '1050398.features.count.name': '4',
  '1050398.features.1.name': 'Earns dividends',
  '1050398.features.2.name': 'Unlimited transactions',
  '1050398.features.3.name': 'No monthly service fees',
  '1050398.features.4.name': 'Potential tax benefits*',
  '1050390.name.name': 'Basic Savings',
  '1050390.description.name': 'Earn and save with a Basic Savings Account! Membership at Carter Credit Union begins with a Share Savings Account. A Share Savings Account allows you to deposit as much money as you like, but you can open one with as little as $5.',
  '1050390.description.abbreviated.name': 'Earn and save with a Basic Savings Account! Membership at Carter Credit Union begins with a Share Savings Account.',
  '1050390.url.name': 'https://www.cartercu.org/Accounts/Savings',
  '1050390.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050390.disclosure.count.name': '1',
  '1050390.disclosure.1.name': '1 $10 charge for each additional withdrawal',
  '1050390.features.count.name': '4',
  '1050390.features.1.name': 'Minimum Opening Balance $5',
  '1050390.features.2.name': 'Earn Dividends on any Balance',
  '1050390.features.3.name': 'No Monthly Service Fees',
  '1050390.features.4.name': '2 Free Withdrawals per Month1',
  '1050391.name.name': 'Rewards Savings',
  '1050391.description.name': 'Your Beyond Rewards Savings is an extra bonus to our Beyond Rewards Checking Account. Earn higher than average earnings with this account while building your savings nest for the future.1 Dividends and ATM refunds from Rewards Checking will be swept to your Rewards Savings each statement cycle to increase savings.',
  '1050391.description.abbreviated.name': 'Earn higher than average earnings with this account while building your savings nest for the future.',
  '1050391.url.name': 'https://www.cartercu.org/Accounts/Savings#Rewards-Savings',
  '1050391.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050391.disclosure.count.name': '1',
  '1050391.disclosure.1.name': '1 Beyond Rewards Savings must be opened in conjunction with your Beyond Rewards Checking Account.',
  '1050391.features.count.name': '5',
  '1050391.features.1.name': 'Free Account',
  '1050391.features.2.name': 'Earns high yield dividend rewards',
  '1050391.features.3.name': 'No minimum balance required',
  '1050391.features.4.name': 'No monthly service fees',
  '1050391.features.5.name': 'Must maintain a Beyond Rewards Checking Account',
  '1050395.name.name': 'Christmas Club',
  '1050395.description.name': "Carter's Christmas Club account is a great way to put a little cash back each month and be prepared for holiday shopping. It seems we end up spending more than we anticipated just about every holiday season. Why not lessen that financial pressure by putting a little cash away ahead of time? This account is specifically designed for Christmas savings with payroll deduction as a perfect option.",
  '1050395.description.abbreviated.name': "Carter's Christmas Club account is a great way to put a little cash back each month and be prepared for holiday shopping.",
  '1050395.url.name': 'https://www.cartercu.org/Accounts/Savings#Christmas-Club',
  '1050395.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050395.disclosure.count.name': '1',
  '1050395.disclosure.1.name': '1 To encourage saving, a $10 fee is charged for any withdrawal/transfer between January and September',
  '1050395.features.count.name': '4',
  '1050395.features.1.name': '$5 minimum opening balance',
  '1050395.features.2.name': 'No monthly service fees',
  '1050395.features.3.name': 'Dividends are earned on any balance',
  '1050395.features.4.name': 'Unlimited withdrawals/transfers between October and December 1',
  '1050392.name.name': 'Money Max',
  '1050392.description.name': "Carter's Money Max account is designed for those who desire to save greater amounts of money, but do not want to tie the funds up in certificates, or risk the principle investment in stocks. If saving is your goal, this is the perfect account for you!",
  '1050392.description.abbreviated.name': 'If saving is your goal, this is the perfect account for you!',
  '1050392.url.name': 'https://www.cartercu.org/Accounts/Savings#Money-Max',
  '1050392.applicationUrl.name': 'https://carterfcu-cloud.lending360.com/AccountOpening/Application?membershipAnchorSet=True#/membership',
  '1050392.disclosure.count.name': '2',
  '1050392.disclosure.1.name': '1 Three transactions can be by check or draft',
  '1050392.disclosure.2.name': '2 If the number of transactions is exceeded or the minimum monthly balance is not maintained an $8 service charge will be assessed.',
  '1050392.features.count.name': '2',
  '1050392.features.1.name': 'Allows up to six transactions during the month1',
  '1050392.features.2.name': 'Minimum monthly balance of $2,500 or greater to avoid service fee2',
  '1050394.name.name': 'Young Savers',
  '1050394.description.name': 'It’s never too early to teach children the importance of saving money. Opening a Young Savers account can help develop early savings habits which will help them throughout their financial future. Start today and put your children and grandchildren on the right track.',
  '1050394.description.abbreviated.name': 'It’s never too early to teach children the importance of saving money.',
  '1050394.url.name': 'https://www.cartercu.org/Accounts/Savings#Young-Savers',
  '1050394.applicationUrl.name': 'https://www.cartercu.org/Resources/Forms-Applications/Account-Application',
  '1050394.disclosure.count.name': '1',
  '1050394.disclosure.1.name': '1 $10 charge for each additional withdrawal',
  '1050394.features.count.name': '4',
  '1050394.features.1.name': 'No monthly service fees',
  '1050394.features.2.name': '2 free teller withdrawals per month 1',
  '1050394.features.3.name': "Establishes individual's Credit Union membership",
  '1050394.features.4.name': 'At 18, the account will be converted to our Basic Savings account',
  
  // Helping Hands.
  'resources.title': 'Resources Just for You',
  'resources.subtitle': 'We’re here to lend a helping hand in efforts to help in your financial recovery during these unprecedented times.  Below are resources, tools and options available to help you, and your family take the first steps toward recovery.',
  '1001050834.title': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.tip.title': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.tip.text': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.icon': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.subtitle': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.footer.text1': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.footer.text2': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.product1.title': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.product1.content': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.product1.linkCluster1.title': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.product1.linkCluster1.link1.title': 'At 18, the account will be converted to our Basic Savings account',
  '1001050834.product1.linkCluster1.link1.href': 'At 18, the account will be converted to our Basic Savings account',
  '100105083.product1.linkCluster1.link1.href': 'At 18, the account will be converted to our Basic Savings account',

  '1001050838.title': 'Taxes',
};
